import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FeaturedInContainer } from "./featured-in.style";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CustomIcon, CustomText } from "@corporate-trip-planner-fe/ui-styles";
import { Tooltip } from "@mui/material";
// the featured in should show the "Featured in {first catgeory} + 2 more"
function FeaturedIn(_a) {
    var _b = _a.categories, categories = _b === void 0 ? [] : _b;
    if (!categories.length)
        return null;
    //console.log("categories: ", categories);
    var firstCategory = categories[0].label;
    var remainingCount = categories.length - 1;
    var tooltipText = categories.map(function (cat) { return cat.label; }).join(", ");
    return (_jsx(Tooltip, { title: remainingCount > 0 ? tooltipText : "", arrow: true, placement: "top", enterDelay: 600, children: _jsxs(FeaturedInContainer, { children: [_jsx(CustomIcon, { "$fontSize": "12px", children: _jsx(TwoWheelerIcon, { fontSize: "inherit" }) }), _jsxs(CustomText, { "$fontSize": "12px", children: ["Featured in", " ", _jsxs("span", { children: [firstCategory, remainingCount > 0 && " +".concat(remainingCount, " more")] })] }), _jsx(CustomIcon, { "$fontSize": "12px", children: _jsx(ArrowForwardIosIcon, { fontSize: "inherit" }) })] }) }));
}
export default FeaturedIn;
